import React, { useEffect } from "react";
import { FiMinus, FiPlus } from "react-icons/fi";
import { RequisitionQuantityInput } from "./popups/RequisitionUnitFields";
import { selectedRequisitionUnit, requisitionUnitOptions } from "../utils/requisitionUnits";
import { marketplaceInitialQuantity, marketplaceQuantityStep } from "../utils/marketplaceSelection";
import usePurchasePricePreviews from "../hooks/usePurchasePricePreviews";

export function MarketplacePriceBatch({ items, supplierId, date, businessUnitId, onResult }) {
  const result = usePurchasePricePreviews({ items, supplierId, date, businessUnitId });
  // The batch is bounded by the same page size as the existing preview hook.
  const signature = JSON.stringify({ ids: items.map((item) => item.id), supplierId, date, prices: result.prices, loading: result.loading, error: result.error });
  useEffect(() => { onResult(JSON.parse(signature)); }, [signature, onResult]);
  return null;
}
export function MarketplaceQuantity({ line, item, units, disabled, onChange, text }) {
  const step = marketplaceQuantityStep(item), minimum = marketplaceInitialQuantity(item);
  const move = (direction) => {
    const quantity = Number(line.quantity) || 0;
    const next = (direction > 0 ? Math.floor(quantity / step + 1e-8) + 1 : Math.ceil(quantity / step - 1e-8) - 1) * step;
    onChange(Number(Math.max(minimum, next).toFixed(8)));
  };
  return <fieldset className="mp-quantity" disabled={disabled}>
    <button type="button" aria-label={text("Reducir cantidad", "Decrease quantity")} disabled={disabled || Number(line.quantity) <= minimum} onClick={() => move(-1)}><FiMinus /></button>
    <RequisitionQuantityInput line={line} item={item} units={units} onChange={onChange} />
    <button type="button" aria-label={text("Aumentar cantidad", "Increase quantity")} disabled={disabled} onClick={() => move(1)}><FiPlus /></button>
  </fieldset>;
}
export function MarketplaceUnit({ line, item, units, languageId, disabled, onChange, text }) {
  const options = requisitionUnitOptions(line, item, units, languageId);
  const selected = selectedRequisitionUnit(line, item, units, languageId);
  if (options.length < 2) return null;
  return <select aria-label={text("Unidad de compra", "Purchase unit")} value={selected.level} disabled={disabled} onChange={(event) => onChange(event.target.value)}>
    {options.map((option) => <option key={option.level} value={option.level}>{option.label}</option>)}
  </select>;
}
